import { styled } from '@mui/material/styles';

export const Container = styled('div', {
    shouldForwardProp: prop => prop !== 'hasConversation',
})(({ hasConversation }) => ({
    display: 'grid',
    height: 'calc(var(--100vh) - 85px)',
    gridTemplateRows: hasConversation ? '57px auto max-content' : '1fr',
    '@media (max-width: 1024px)': {
        height: 'calc(var(--100vh) - 124px)',
    },
}));

export const Header = styled('div')({
    display: 'grid',
    padding: '0 16px 13px 16px',
    gridGap: '0 16px',
    gridTemplateColumns: '40px minmax(50px, 1fr) auto',
    alignItems: 'center',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    '@media (max-width: 1280px)': {
        gridGap: '0 8px',
    },
    '@media (max-width: 768px)': {
        gridTemplateColumns: '32px 32px minmax(0, 100%) max-content',
        padding: '0 8px 13px 8px',
        gridGap: '0 8px',
    },
});

export const Feed = styled('div')({
    overflowY: 'auto',
    padding: 16,
    display: 'flex',
    flexFlow: 'column-reverse',
    gap: 8,
    '@media (max-width: 768px)': {
        padding: 8,
    },
});

export const Footer = styled('div')({
    padding: 16,
    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
    position: 'relative',
    '@media (max-width: 768px)': {
        padding: 8,
    },
});
